import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.406 14.805c-1.197-1-2.994-.9-4.092.1-2.395 1.998-.798 2.998-3.094 5.796-.499.5-.1 1.299.699 1.299 1.896-.1 4.89-.7 6.587-2.798 1.098-1.4 1.198-3.198-.1-4.397zM21.782 2.213C20.185.614 12.7 8.41 9.107 12.107c-.1.1-.1.3.1.3.598.2 1.097.5 1.497.899.499.4.798.9 1.098 1.399.1.2.2.2.299.1 3.693-3.698 11.278-10.993 9.681-12.592z",
      fill: "#2d6ded"
    }
  )
), n = l;
export {
  n as default
};
